/*
<script async="async" data-cfasync="false" src="https://annoyingnightmareedit.com/fd6e97ee76c43cfd008df283ae0ad7d4/invoke.js"></script>
<div id="container-fd6e97ee76c43cfd008df283ae0ad7d4"></div>
*/
import React, { useEffect, useRef } from 'react';

const AdComponent = () => {
  const scriptLoaded = useRef(false);
  const containerId = 'container-fd6e97ee76c43cfd008df283ae0ad7d4';

  useEffect(() => {
    // Prevent duplicate script loading
    if (scriptLoaded.current) return;

    const script = document.createElement('script');
    script.src = 'https://annoyingnightmareedit.com/fd6e97ee76c43cfd008df283ae0ad7d4/invoke.js';
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    
    script.onload = () => {
      console.log('Ad script loaded successfully');
    };
    
    script.onerror = (error) => {
      console.error('Failed to load ad script:', error);
    };

    document.head.appendChild(script);
    scriptLoaded.current = true;

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      scriptLoaded.current = false;
    };
  }, []);

  return React.createElement('div', { id: containerId });
};

export default AdComponent; 